/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HttpStatusCode } from './HttpStatusCode';
import {
	HttpStatusCodeFromJSON,
	HttpStatusCodeFromJSONTyped,
	HttpStatusCodeToJSON,
	HttpStatusCodeToJSONTyped,
} from './HttpStatusCode';

/**
 *
 * @export
 * @interface BaseResponse
 */
export interface BaseResponse {
	/**
	 *
	 * @type {HttpStatusCode}
	 * @memberof BaseResponse
	 */
	statusCode?: HttpStatusCode;
	/**
	 *
	 * @type {Array<Error>}
	 * @memberof BaseResponse
	 */
	errors?: Array<Error> | null;
}

/**
 * Check if a given object implements the BaseResponse interface.
 */
export function instanceOfBaseResponse(value: object): value is BaseResponse {
	return true;
}

export function BaseResponseFromJSON(json: any): BaseResponse {
	return BaseResponseFromJSONTyped(json, false);
}

export function BaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseResponse {
	if (json == null) {
		return json;
	}
	return {
		statusCode: json['statusCode'] == null ? undefined : HttpStatusCodeFromJSON(json['statusCode']),
		errors: json['errors'] == null ? undefined : json['errors'],
	};
}

export function BaseResponseToJSON(json: any): BaseResponse {
	return BaseResponseToJSONTyped(json, false);
}

export function BaseResponseToJSONTyped(
	value?: BaseResponse | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		statusCode: HttpStatusCodeToJSON(value['statusCode']),
		errors: value['errors'],
	};
}
